import PostsAdmin from './PostsAdmin';

export default PostsAdmin;
